(() => {
  const storageKey = 'modanie:wishlist:v1';
  let memoryWishlist = [];

  const readWishlist = () => {
    try {
      const stored = window.localStorage.getItem(storageKey);
      if (stored === null) return memoryWishlist;
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.filter((item) => typeof item === 'string') : memoryWishlist;
    } catch (error) {
      return memoryWishlist;
    }
  };

  const writeWishlist = (items) => {
    memoryWishlist = [...new Set(items)];
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(memoryWishlist));
    } catch (error) {
      // Keep the current session usable when browser storage is unavailable.
    }
  };

  const syncButtons = () => {
    const saved = new Set(readWishlist());
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const handle = button.dataset.productHandle;
      if (!handle) return;
      const active = saved.has(handle);
      const label = active ? button.dataset.wishlistRemoveLabel : button.dataset.wishlistAddLabel;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', label || '');
      button.setAttribute('title', label || '');
      const icon = button.querySelector('[data-wishlist-icon]');
      if (icon) icon.textContent = active ? '♥' : '♡';
      const text = button.querySelector('[data-wishlist-label]');
      if (text && label) text.textContent = label;
    });
  };

  document.addEventListener('click', (event) => {
    const target = event.target;
    const button = target instanceof Element ? target.closest('[data-wishlist-toggle]') : null;
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.productHandle;
    if (!handle) return;
    const saved = new Set(readWishlist());
    if (saved.has(handle)) saved.delete(handle);
    else saved.add(handle);
    writeWishlist([...saved]);
    syncButtons();
    document.dispatchEvent(new CustomEvent('modanie:wishlist:change', {detail: {handles: [...saved]}}));
  });
  document.addEventListener('DOMContentLoaded', syncButtons);
  document.addEventListener('shopify:section:load', syncButtons);
  document.addEventListener('shopify:section:reorder', syncButtons);
  syncButtons();
})();
